import * as React from "react";
import type { SVGProps } from "react";
const SvgBeachUmbrellaAndPalmTree = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#beach-umbrella-and-palm-tree_svg__a)">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M1.94 12.32c.412-1.242 1.474-2.314 2.463-3.092C4.187 10.321 4 11.654 4 13c0 .55.45 1 1 1l-.01-.01c.55 0 1-.45 1-1 0-1.293.204-2.6.423-3.635C8.166 12.149 8.769 14.813 8.126 20H3c-.55 0-1 .45-1 1s.45 1 1 1h6v.01a1 1 0 0 0 .14-.01H21c.55 0 1-.45 1-1s-.45-1-1-1h-5.726l2.095-3.631.795.459a1 1 0 0 0 .13.075L21.7 18.87c.149.08.327.13.495.13h-.005.01-.005c.089 0 .177-.01.255-.03.26-.07.48-.24.61-.47 1.93-3.34.78-7.63-2.56-9.56s-7.63-.78-9.56 2.56a.998.998 0 0 0 .37 1.37l3.356 1.938a1 1 0 0 0 .19.11l.775.447L13.13 19.7q-.08.145-.111.3H10.14c.715-6.104-.284-9.218-2.634-12.613.937-.324 2.446-.553 3.944.443.17.12.36.17.55.17h.01c.32 0 .64-.16.83-.45.3-.46.18-1.08-.28-1.39-1.07-.71-2.13-.999-3.095-1.053.898-.447 2.099-.86 3.695-1.127.54-.09.91-.61.82-1.15a.99.99 0 0 0-1.15-.82c-2.981.5-4.853 1.49-6.011 2.43.11-.594.364-1.213.881-1.73A.996.996 0 1 0 6.29 1.3C4.894 2.696 4.683 4.444 4.761 5.697 3.568 5.506 1.902 5.434.55 6.11c-.5.25-.7.85-.45 1.34.18.35.53.55.9.55l-.01.01c.15 0 .31-.04.45-.11.534-.269 1.204-.353 1.863-.34C2.052 8.528.633 9.944.05 11.69c-.18.52.11 1.09.63 1.26.108.03.217.05.316.05H.99 1 .996a1 1 0 0 0 .944-.68m19.81 4.26-1.672-.965c.57-1.123.988-2.235 1.207-3.21a5.01 5.01 0 0 1 .465 4.175m-8.48-4.9a5 5 0 0 1 3.797-1.676c-.753.696-1.492 1.619-2.15 2.633l-1.657-.957zm5.07 2.931-1.68-.97c1.192-1.808 2.31-2.7 2.79-2.891.07.514-.142 1.925-1.11 3.861"
        clipRule="evenodd"
      />
    </g>
    <defs>
      <clipPath id="beach-umbrella-and-palm-tree_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgBeachUmbrellaAndPalmTree;
